<template>
  <div>
    <CModal v-show="fileModal" @close="closeFileModal" footer>
      <template v-slot:title>
        <h5>Create filters</h5>
      </template>
      <template v-slot:body>
        <div class="p-1">
          <div class="form-group">
            <label for="">File Category</label>
            <select
              name="file_type"
              v-model="file_info.name"
              class="form-control"
            >
              <option value selected disabled>Select File Category</option>
              <option
                v-for="file in file_names"
                :key="file.name"
                :value="file.name"
                >{{ file.name }}</option
              >
            </select>
          </div>
          <div>
            <div class="form-group">
              <label for="">File Description</label>
              <textarea
                name="file_description"
                v-model="file_info.comment"
                class="form-control"
              ></textarea>
            </div>
          </div>
          <div class="form-group">
            <button
              class=" btn btn-secondary d-block mt-1"
              @click="onPickFileButton"
            >
              <span v-if="file_info.file">
                Change File Image
              </span>
              <span v-else>
                Upload File Image
              </span>
            </button>
            <input
              type="file"
              class="upload"
              ref="fileChangeFile"
              accept="*"
              style="display:none;"
              @change="onFilePickedFileButton()"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-secondary" @click="closeFileModal">
          Close
        </button>
        <button
          class="btn btn-primary"
          @click="createFile"
          :disabled="create_file_loading"
        >
          <span class="custom-loader" v-if="create_file_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>Create File</span>
        </button>
      </template>
    </CModal>
    <CModal v-show="guarantorModal" @close="closeGuranatorModal" footer>
      <template v-slot:title>
        <h5>Create Gurantor</h5>
      </template>
      <template v-slot:body>
        <div class="p-1">
          <div class="form-group">
            <label for="">Name</label>
            <input
              type="text"
              placeholder="Collection Name"
              class="form-control"
              v-model="guarantor_info.name"
            />
          </div>
          <div class="form-group">
            <label for="">Address</label>
            <input
              type="text"
              placeholder="Collection Address"
              class="form-control"
              v-model="guarantor_info.address"
            />
          </div>
          <div class="form-group">
            <label for="">Phone Number</label>
            <input
              type="text"
              placeholder="Collection Phone Number"
              class="form-control"
              v-model="guarantor_info.phone_number"
            />
          </div>
          <div class="form-group">
            <label for="">Alternative Phone Number</label>
            <input
              type="text"
              placeholder="Collection Alternative Phone Number"
              class="form-control"
              v-model="guarantor_info.alt_phone_number"
            />
          </div>
          <div class="form-group">
            <button
              class=" btn btn-secondary d-block mt-1"
              @click="onPickGuarantorImageButton"
            >
              <span v-if="guarantor_info.image_file">
                Change Guarantor Image
              </span>
              <span v-else>
                Upload Guarantor Image
              </span>
            </button>
            <input
              type="file"
              class="upload"
              ref="fileChangeGuarantorImage"
              accept="*"
              style="display:none;"
              @change="onFilePickedGuarantorImageButton()"
            />
          </div>
          <div class="form-group">
            <button
              class=" btn btn-secondary d-block mt-1"
              @click="onPickButtonGuarantorIdButton"
            >
              <span v-if="guarantor_info.id_file">
                Change Guarantor ID
              </span>
              <span v-else>
                Upload Guarantor ID
              </span>
            </button>
            <input
              type="file"
              class="upload"
              ref="fileChangeGuarantorId"
              accept="*"
              style="display:none;"
              @change="onFilePickedGuarantorIdButton()"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-secondary" @click="closeGuranatorModal">
          Close
        </button>
        <button
          class="btn btn-primary"
          @click="createGuarantor"
          :disabled="create_guarantor_loading"
        >
          <span class="custom-loader" v-if="create_guarantor_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>Create Collection</span>
        </button>
      </template>
    </CModal>
    <CModal
      modalIsLarge
      v-show="riskReviewwModal"
      @close="closeRiskReviewModal"
      footer
    >
      <template v-slot:title>
        <h5>Review Loan Review Status</h5>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center">
          <div class="col-md-11 form-group">
            <label for="">Review Status</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="risk_review.status"
            >
              <option value="" selected disabled>Please Select Review</option>
              <option value="very-high">VeryHigh</option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="fair">Fair</option>
              <option value="low">Low</option>
              <option value="reject-application">Reject Application</option>
            </select>
          </div>
          <div class="col-md-11 form-group">
            <label for="">Risk Analysis</label>
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              style="resize:none"
              v-model="risk_review.risk_analysis"
              class=" form-control"
            ></textarea>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-danger" @click.prevent="closeRiskReviewModal">
          Close
        </button>
        <button
          class="btn btn-primary"
          :disabled="risk_review_loading || risk_review.risk_analysis === ''"
          @click.prevent="submitRiskAssesment"
        >
          <span class="custom-loader" v-if="risk_review_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>Submit Risk Analysis</span>
        </button>
      </template>
    </CModal>
    <CModal v-show="appReviewwModal" @close="closeAppReviewModal" footer>
      <template v-slot:title>
        <h5>Review Loan Application Status</h5>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center">
          <div class="col-md-11 form-group">
            <label for="">Status</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="app_review.status"
            >
              <option value="" selected disabled>Please Select Review</option>
              <option value="rejected">Reject</option>
              <option value="approved">Approve</option>
              <option value="reject-risk-assessement"
                >Reject Risk Analysis</option
              >
            </select>
          </div>
          <div class="col-md-11 form-group">
            <label for="">Review Comment</label>
            <textarea
              name=""
              id=""
              cols="30"
              rows="2"
              style="resize:none"
              v-model="app_review.review_notes"
              class=" form-control"
            ></textarea>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-danger" @click.prevent="closeAppReviewModal">
          Close
        </button>
        <button
          class="btn btn-primary"
          :disabled="app_review_loading || risk_review.statuss === ''"
          @click.prevent="submitAppReview"
        >
          <span class="custom-loader" v-if="app_review_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>Treat Application</span>
        </button>
      </template>
    </CModal>
    <CModal v-show="disbursementModal" @close="closeDisbursemenModal" footer>
      <template v-slot:title>
        <h5>Disburse Loan</h5>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center">
          <div class="col-md-12 form-group">
            <label for="">Review Status</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="disursement_info.status"
            >
              <option value="" selected disabled>Please Select Status</option>
              <option value="approved">Approve</option>
              <option value="cancel">Cancel</option>
            </select>
          </div>
          <div v-if="disursement_info.status == 'approved'">
            <div class="col-md-12 form-group">
              <label for="">Duration</label>
              <input
                type="text"
                v-model="disursement_info.duration"
                class=" form-control"
              />
            </div>
            <div class="col-md-12 form-group">
              <label for="">Interest Rate</label>
              <input
                type="text"
                v-model="disursement_info.interest_rate"
                class=" form-control"
              />
            </div>
            <div class="col-md-12 form-group">
              <label for="">Charges(%)</label>
              <input
                type="text"
                v-model="disursement_info.charges"
                class=" form-control"
              />
            </div>
            <div class="col-md-12 form-group">
              <label for="">Approved Amount</label>
              <input
                type="text"
                v-model="disursement_info.amount_approved"
                class=" form-control"
              />
            </div>
            <div class="col-md-12 form-group">
              <label for="">Loan Account Number</label>
              <input
                type="text"
                v-model="disursement_info.loan_account_number"
                class=" form-control"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-danger" @click.prevent="closeAppReviewModal">
          Close
        </button>
        <button
          class="btn btn-primary"
          :disabled="app_review_loading || risk_review.statuss === ''"
          @click.prevent="disburseLoan"
        >
          <span class="custom-loader" v-if="app_review_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>Treat</span>
        </button>
      </template>
    </CModal>
    <CModal
      v-show="updateLoanStatusModal"
      @close="closeUpdateLoanStatusModal"
      footer
    >
      <template v-slot:title>
        <h5>Update Loan Application Status</h5>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center">
          <div class="col-md-11 form-group">
            <label for="">Loan Status</label>
            <select name="" id="" class="form-control" v-model="loan_status">
              <option value="" selected disabled>Please Select Status</option>
              <option value="pending">Pending</option>
              <option value="rejected">Rejected</option>
              <option value="completed">Completed</option>
              <option value="active">Active</option>
              <option value="closed">Closed</option>
              <option value="overtune-risk-assessement"
                >Overtun Risk Assesment</option
              >
              <option value="disburse-loan">Disburse Loan</option>
            </select>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-danger"
          @click.prevent="closeUpdateLoanStatusModal"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          :disabled="laon_status_loading || loan_status === ''"
          @click.prevent="updateLoanStatus"
        >
          <span class="custom-loader" v-if="laon_status_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait</span
            >
          </span>
          <span v-else>Treat Application</span>
        </button>
      </template>
    </CModal>
    <CModal v-show="isRepayVisible" @close="closeRepayModal" footer>
      <template v-slot:title>
        <h5 class=" fw-bold">Repayment</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="">Payment Method</label>
              <select name="" v-model="r_payment_method" class="form-control">
                <option value="" selected disabled
                  >Please Select Payment Method</option
                >
                <option value="loan-pool">Loan Pool Account</option>
                <option value="normal">Normal</option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Amount</label>
              <input
                type="text"
                class="form-control"
                @keypress="isNumber($event)"
                v-model="r_amount"
                placeholder="Enter Amount"
              />
            </div>
            <div class="form-group">
              <label for="">Description</label>
              <input
                type="text"
                class="form-control"
                v-model="r_payment_description"
                placeholder="Enter Description"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class=" btn btn-secondary" @click="closeRepayModal">
          Close
        </button>
        <button class=" btn btn-primary" @click="createRepayment">
          Perform Action
        </button>
      </template>
    </CModal>
    <page-loader :pageLoading="pageLoading" :message="message" />
    <div class="main-menu-content" v-if="loanData !== null">
      <div @click="$router.go(-1)" class="arrow_text cursor-pointer width-100">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </div>

      <h3 class="font-regular mb-2 mt-1">Loan One Profile</h3>
      <div class="row mb-2">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
                >General Info</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
                >Guarantors</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
                >Files</a
              >
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 4"
                v-bind:class="[activetab === 4 ? 'active' : '']"
                >Trails</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 5"
                v-bind:class="[activetab === 5 ? 'active' : '']"
                >Credit Report</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 6"
                v-bind:class="[activetab === 6 ? 'active' : '']"
                >Repayments</a
              >
            </li>
          </CScrollbar>
        </div>
      </div>
      <!-- General Info -->
      <div class="row" v-if="activetab === 1">
        <div class="col-md-8">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Loan Info</h3>
              <div class="pull-right">
                <strong>Loan Status : </strong>
                <span
                  v-if="
                    loanData.loan_status === 'pending' ||
                      loanData.loan_status == 'in-review' ||
                      loanData.loan_status == 'awaiting-disbursement'
                  "
                  class="badge badge-warning"
                >
                  {{ loanData.loan_status }}
                </span>
                <span
                  v-if="loanData.loan_status == 'rejected'"
                  class="badge badge-danger"
                  >Rejected</span
                >
                <span
                  v-if="
                    loanData.loan_status == 'approved' ||
                      loanData.loan_status == 'active'
                  "
                  class="badge badge-success"
                  >{{ loanData.loan_status }}</span
                >
                <span
                  v-if="loanData.loan_status == 'overdue'"
                  class="badge badge-primary"
                  >{{ loanData.loan_status }}</span
                >

                <span
                  v-if="loanData.loan_status == 'completed'"
                  class="badge badge-secondary"
                  >{{ loanData.loan_status }}</span
                >

                <strong>Risk Status : </strong>
                <span
                  v-if="
                    loanData.risk_status === 'high' ||
                      loanData.risk_status === 'very-high'
                  "
                  class="badge badge-danger"
                >
                  {{ loanData.risk_status }}
                </span>
                <span
                  v-if="loanData.risk_status === 'pending'"
                  class="badge badge-warning"
                >
                  {{ loanData.risk_status }}
                </span>
                <span
                  v-if="loanData.risk_status === 'low'"
                  class="badge badge-success"
                >
                  {{ loanData.risk_status }}
                </span>
                <span
                  v-if="loanData.risk_status == 'rejected'"
                  class="badge badge-danger"
                  >Rejected</span
                >
                <strong>Approval Status : </strong>
                <span
                  v-if="
                    loanData.approval_status === 'pending' ||
                      loanData.approval_status === 'in-review'
                  "
                  class="badge badge-warning"
                >
                  {{ loanData.approval_status }}
                </span>
                <span
                  v-if="loanData.approval_status === 'rejected'"
                  class="badge badge-danger"
                >
                  {{ loanData.approval_status }}
                </span>
                <span
                  v-if="
                    loanData.approval_status === 'approved' ||
                      loanData.approval_status === 'active'
                  "
                  class="badge badge-success"
                >
                  {{ loanData.approval_status }}
                </span>

                <strong>Disbursement Status : </strong>
                <span
                  v-if="
                    loanData.disbursement_status === 'pending' ||
                      loanData.disbursement_status === 'in-review'
                  "
                  class="badge badge-warning"
                >
                  {{ loanData.disbursement_status }}
                </span>
                <span
                  v-if="loanData.disbursement_status === 'rejected'"
                  class="badge badge-danger"
                >
                  {{ loanData.disbursement_status }}
                </span>
                <span
                  v-if="
                    loanData.disbursement_status === 'disbursed' ||
                      loanData.disbursement_status === 'disbursed'
                  "
                  class="badge badge-success"
                >
                  {{ loanData.disbursement_status }}
                </span>
                <strong v-if="loanData.due_date"
                  >Approval Status : {{ loanData.due_date }}</strong
                >
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Account Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        readonly
                        v-model="loanData.account_name"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Account Number</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        readonly
                        v-model="loanData.account_number"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">BVN</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        readonly
                        v-model="loanData.bvn"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" v-if="loanData.referred">
                    <div class="form-group">
                      <label for="title">Referred BY</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        readonly
                        v-bind:value="
                          loanData.referred.first_name +
                            ' ' +
                            loanData.referred.last_name
                        "
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="title">Address</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        v-model="loanData.address"
                        :disabled="application_editable"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">City</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        v-model="loanData.city"
                        :disabled="application_editable"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="state">State</label>
                      <select
                        name="state"
                        v-model="loanData.state_id"
                        class="form-control"
                        :disabled="application_editable"
                      >
                        <option value selected disabled>Select state</option>
                        <option
                          :value="state.id"
                          v-for="state in states"
                          :key="state.id"
                          >{{ state.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Nature of Business</label>
                      <select
                        name="nature_of_business"
                        v-model="loanData.nature_of_business"
                        :disabled="application_editable"
                        class="form-control"
                      >
                        <option value selected disabled
                          >Select Nature of Business</option
                        >
                        <option value="employed">Employed</option>
                        <option value="self-employed">Self Employed</option>
                        <option value="others">Others</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Business Description</label>
                      <textarea
                        name="business_description"
                        v-model="loanData.business_description"
                        :disabled="application_editable"
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Duration(Months)</label>
                      <input
                        type="number"
                        class="form-control"
                        name="title"
                        v-model="loanData.duration"
                        :disabled="application_editable"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Payment Frequency</label>
                      <select
                        name="payment_frequency"
                        v-model="loanData.payment_frequency"
                        class="form-control"
                        :disabled="application_editable"
                      >
                        <option value selected disabled
                          >Select Payment Frequency</option
                        >
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="title">Amount</label>
                      <input
                        type="number"
                        class="form-control"
                        name="title"
                        v-model="loanData.amount_requested"
                        :disabled="application_editable"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row justify-content-around">
                <button
                  class="btn btn-warning w-auto"
                  @click.prevent="submitApplication"
                  v-if="
                    (loanData.loan_status === 'pending' ||
                      loanData.loan_status === 'rejected') &&
                      permissions.includes('submit-other-loan-application')
                  "
                >
                  <span v-if="submit_loading">Please wait...</span>
                  <span v-else>Submit Application</span>
                </button>

                <button
                  class="btn btn-primary w-auto"
                  @click.prevent="showRiskReviewModal"
                  v-if="
                    permissions.includes(
                      'add-risk-assesment-other-loan-application'
                    ) &&
                      (loanData.risk_status == 'pending' ||
                        loanData.risk_status == 'rejected')
                  "
                >
                  Record Risk Assesment
                </button>

                <button
                  @click="showAppReviewModal"
                  v-if="
                    permissions.includes('review-other-loan-application') &&
                      loanData.loan_status == 'in-review' &&
                      loanData.risk_status != 'pending'
                  "
                  class="btn btn-success w-auto"
                >
                  Review Application
                </button>

                <button
                  @click="showDisbursementModal"
                  v-if="
                    permissions.includes('disburse-other-loan-application') &&
                      loanData.loan_status == 'awaiting-disbursement' &&
                      loanData.approval_status == 'approved'
                  "
                  class="btn btn-secondary w-auto"
                >
                  Disburse Loan
                </button>

                <button
                  @click="showUpdateLoanStatusModal"
                  v-if="permissions.includes('update-other-loan-status')"
                  class="btn btn-success w-auto"
                >
                  Update Loan Status
                </button>

                <button
                  @click="updateLoanCBAStatus"
                  v-if="loanData.loan_status == 'active'"
                  class="btn btn-success w-auto"
                >
                  Update Loan CBA Status
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Analysis</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div
                  class="alert mb-4"
                  :class="
                    loanData.risk_status === 'high' ||
                    loanData.risk_status === 'very-high'
                      ? 'alert-danger'
                      : loanData.risk_status === 'low'
                      ? 'alert-success'
                      : 'alert-warning'
                  "
                >
                  <h3>Risk Analysis</h3>
                  {{
                    loanData.risk_analysis ? loanData.risk_analysis : "No Yet"
                  }}
                </div>

                <div
                  class="alert  mb-4"
                  :class="
                    loanData.approval_status === 'approved'
                      ? 'alert-success'
                      : loanData.approval_status === 'rejected'
                      ? 'alert-danger'
                      : 'alert-warning'
                  "
                >
                  <h3>Approval Analysis</h3>
                  {{ loanData.review_notes ? loanData.review_notes : "No Yet" }}
                </div>
                <div v-if="loanData.disbursement_status == 'disbursed'">
                  <KeyValue objKey="Charges" :objValue="loanData.charges" />
                  <KeyValue
                    objKey="Interest Rate(%)"
                    :objValue="loanData.interest_rate"
                  />
                  <KeyValue
                    objKey="Interest Amount"
                    :objValue="loanData.interest_amount"
                  />
                  <KeyValue
                    objKey="Requested Amount"
                    :objValue="loanData.amount_requested"
                  />
                  <KeyValue
                    objKey="Disbursed Amount"
                    :objValue="loanData.disbursed_amount"
                  />
                  <KeyValue
                    objKey="Loan Balance"
                    :objValue="loanData.loan_balance"
                  />
                  <KeyValue
                    objKey="Total Amount"
                    :objValue="loanData.total_amount"
                  />
                  <KeyValue
                    objKey="Duration(Days)"
                    :objValue="loanData.duration"
                  />
                  <KeyValue
                    v-if="loanData.core_banking_loan_reference"
                    objKey="CBA Loan Ref"
                    :objValue="loanData.core_banking_loan_reference"
                  />
                  <KeyValue
                    v-if="loanData.cba_principal_balance"
                    objKey="CBA Principal Balance"
                    :objValue="loanData.cba_principal_balance"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card card--no-shadow card-profile" v-if="loanData.user">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Personal Info</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <KeyValue
                  objKey="First Name"
                  :objValue="loanData.user.first_name"
                />
                <KeyValue
                  objKey="Last Name"
                  :objValue="loanData.user.last_name"
                />
                <KeyValue
                  objKey="Other Name"
                  :objValue="loanData.user.other_name"
                />
                <KeyValue
                  objKey="Date Of Birth"
                  :objValue="loanData.user.date_of_birth | date_two"
                />
                <KeyValue
                  objKey="Age"
                  :objValue="loanData.user.date_of_birth | date_three"
                />
                <KeyValue objKey="Email" :objValue="loanData.user.email" />
                <KeyValue objKey="Gender" :objValue="loanData.user.gender" />
                <KeyValue
                  objKey="Phone Number"
                  :objValue="loanData.user.phone_number"
                />
                <KeyValue objKey="BVN" :objValue="loanData.user.kyc.bvn" />
                <KeyValue
                  objKey="BVN Status"
                  :objValue="loanData.user.kyc.bvn_status"
                />
                <KeyValue
                  objKey="Address"
                  :objValue="loanData.user.kyc.address"
                />
                <KeyValue objKey="City" :objValue="loanData.user.kyc.city" />

                <KeyValue
                  objKey="Next of Kin"
                  :objValue="
                    `${
                      loanData.user.kyc.nok_firstname
                        ? loanData.user.kyc.nok_firstname
                        : ''
                    } ${
                      loanData.user.kyc.nok_lastname
                        ? loanData.user.kyc.nok_lastname
                        : ''
                    }`
                  "
                />
                <KeyValue
                  objKey="NOK Email"
                  :objValue="loanData.user.kyc.nok_email"
                />
                <KeyValue
                  objKey="NOK Phone Number"
                  :objValue="loanData.user.kyc.nok_phone_number"
                />
                <KeyValue
                  objKey="NOK Address"
                  :objValue="loanData.user.kyc.nok_full_address"
                />
              </div>
            </div>
            <div class="card-footer">
              <div class="row justify-content-around">
                <button
                  v-if="permissions.includes('view-customer')"
                  class="btn btn-primary w-auto"
                  @click="openNewTab(loanData.user_id)"
                >
                  More Info
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activetab === 2" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Guarantors</h4>
          <button
            class="btn btn-primary"
            @click="showGuarantorModal"
            v-if="
              (loanData.loan_status === 'pending' ||
                loanData.loan_status === 'rejected') &&
                permissions.includes('create-other-loan-guarantors')
            "
          >
            Upload New Guarantor
          </button>
        </div>
        <CDataTable
          :items="loanData.guarantors"
          :fields="guarantorFields"
          pagination
        >
          <template #action="{ item }">
            <td>
              <a
                :href="item.id_file"
                class="btn btn-sm btn-primary"
                target="_blank"
                >View ID</a
              >
              <a
                :href="item.image_file"
                class="btn btn-sm btn-primary"
                target="_blank"
                >View Image File</a
              >
              <button
                class="btn btn-sm btn-danger"
                @click="deleteGuarantor(item.id)"
                v-if="
                  (loanData.loan_status === 'pending' ||
                    loanData.loan_status === 'rejected') &&
                    permissions.includes('delete-other-loan-guarantors')
                "
              >
                Delete
              </button>
            </td>
          </template>
        </CDataTable>
      </div>
      <div v-if="activetab === 3" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Files</h4>
          <button
            class="btn btn-primary"
            @click="showFileModal"
            v-if="
              (loanData.loan_status === 'pending' ||
                loanData.loan_status === 'rejected') &&
                permissions.includes('create-other-loan-file')
            "
          >
            Create File
          </button>
        </div>
        <CDataTable :items="loanData.files" :fields="fileFields" pagination>
          <template #action="{ item }">
            <td>
              <a
                :href="item.file_url"
                class="btn btn-sm btn-primary"
                target="_blank"
                >View File</a
              >
              <button
                class="btn btn-sm btn-danger"
                @click="deleteFile(item.id)"
                v-if="
                  (loanData.loan_status === 'pending' ||
                    loanData.loan_status === 'rejected') &&
                    permissions.includes('delete-other-loan-file')
                "
              >
                Delete
              </button>
            </td>
          </template>
        </CDataTable>
      </div>
      <div v-if="activetab === 4" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Trails</h4>
        </div>
        <CDataTable :items="loanTrails" :fields="loanTrailsFields" pagination>
          <template #userdetails="{ item }">
            <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
          </template>
        </CDataTable>
      </div>
      <div v-if="activetab === 5" class="p-2">
        <div class="p-2">
          <div class="row" v-if="credit_report">
            <h4>Credit Report</h4>
            <div class="col-md-12">
              <h3>
                {{ credit_report.header }}
              </h3>
            </div>
            <div class="col-md-4">
              <div class="card card--no-shadow card-profile">
                <div class="card-header">
                  <h3 class="font-weight-600 mb-0">Scoring</h3>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <KeyValue
                      objKey="Score Risk"
                      :objValue="credit_report.score_description"
                    />
                    <KeyValue
                      objKey="Repayment History Score"
                      :objValue="credit_report.repayment_history_score"
                    />
                    <KeyValue
                      objKey="Total Amount Owned Score"
                      :objValue="credit_report.total_amount_owned_score"
                    />
                    <KeyValue
                      objKey="Type of Credit Score"
                      :objValue="credit_report.types_of_credit_score"
                    />
                    <KeyValue
                      objKey="Length of Credit History Score"
                      :objValue="credit_report.length_of_credit_history_score"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card card--no-shadow card-profile">
                <div class="card-header">
                  <h3 class="font-weight-600 mb-0">Account</h3>
                </div>
                <div class="card-content">
                  <div class="card-body">
                    <div
                      class="transaction-details"
                      v-for="(value,
                      name,
                      index) in credit_report.credit_account_summary"
                      :key="index"
                    >
                      <KeyValue
                        :objKey="name"
                        :objValue="value"
                        v-if="value != '0'"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <CDataTable
                :items="credit_report.credit_agreement_summary"
                :fields="creditAgreementSummaryFields"
                pagination
              >
              </CDataTable>
            </div>
          </div>
          <div v-else>
            <h3>No Credit Report Yet</h3>
          </div>
        </div>
      </div>
      <div v-if="activetab === 6" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Repayments</h4>
          <button
            class="btn btn-primary"
            @click="showRepaymentModal"
            v-if="
              loanData.loan_status === 'active'
              //&& permissions.includes('create-other-loan-guarantors')
            "
          >
            Create Repayment
          </button>
        </div>
        <CDataTable
          :items="loanData.repayments"
          :fields="repaymentFields"
          pagination
        >
          <template #action="{ item }">
            <td>
              <a
                :href="item.id_file"
                class="btn btn-sm btn-primary"
                target="_blank"
                >View ID</a
              >
            </td>
          </template>
        </CDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import KeyValue from "../../components/KeyValue.vue";
import CCard from "../../components/CCard.vue";
import CScrollbar from "../../components/CScrollbar.vue";
import img from "@/assets/img/team.jpg";
import Swal from "sweetalert2";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import CModal from "../../components/CModal.vue";
import ErrorService from "../../services/error.service";
import VerifyIdentity from "../../components/VerifyIdentity.vue";

const guarantorFields = [
  "name",
  "phone_number",
  "alt_phone_number",
  "address",
  "action"
];

const repaymentFields = [
  "description",
  "amount",
  "payment_method",
  "status",
  "action"
];

const fileFields = ["name", "comment", "action"];

const loanTrailsFields = ["userdetails", "description", "action", "date"];

export default {
  name: "ViewOtherLoanDetail",
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  components: {
    CModal,
    CCard,
    KeyValue,
    CScrollbar,
    CDataTable,
    VerifyIdentity
  },
  data() {
    return {
      pageLoading: true,
      message: "Loading...",
      loanData: null,
      activetab: 1,
      application_editable: true,
      states: [],
      guarantors: [],
      guarantorModal: false,
      fileModal: false,
      guarantor_info: {
        id: null,
        name: null,
        address: null,
        phone_number: null,
        alt_phone_number: null,
        image_file: null,
        id_file: null
      },
      file_info: {
        name: null,
        file: null,
        comment: null
      },
      create_guarantor_loading: false,
      create_file_loading: false,
      submit_loading: false,
      guarantorFields,
      fileFields,
      file_names: [
        { name: "Bank Statement" },
        { name: "Utility Bill" },
        { name: "ID" },
        { name: "Passport" },
        { name: "Loan Application Form" },
        { name: "Guarantor Video" },
        { name: "Others" }
      ],
      riskReviewwModal: false,
      risk_review: {
        status: "",
        risk_analysis: ""
      },
      risk_review_loading: false,
      appReviewwModal: false,
      app_review: {
        status: "",
        review_notes: ""
      },
      disbursementModal: false,
      disursement_info: {
        status: null,
        duration: null,
        interest_rate: null,
        loan_account_number: null,
        amount_approved: null,
        charges: null
      },
      app_review_loading: false,
      loanTrails: [],
      loanTrailsFields,
      repaymentFields,
      loan_status: "",
      updateLoanStatusModal: false,
      laon_status_loading: false,
      isRepayVisible: false,
      r_payment_method: "",
      r_amount: "",
      r_payment_description: ""
    };
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showRepaymentModal() {
      this.isRepayVisible = true;
    },
    closeRepayModal() {
      this.isRepayVisible = false;
    },
    showUpdateLoanStatusModal() {
      this.updateLoanStatusModal = true;
    },
    closeUpdateLoanStatusModal() {
      this.updateLoanStatusModal = false;
    },
    showRiskReviewModal() {
      this.riskReviewwModal = true;
    },
    closeRiskReviewModal() {
      this.riskReviewwModal = false;
    },
    showAppReviewModal() {
      this.appReviewwModal = true;
    },
    closeAppReviewModal() {
      this.appReviewwModal = false;
    },
    showDisbursementModal() {
      this.disbursementModal = true;
    },
    closeDisbursemenModal() {
      this.disbursementModal = false;
    },
    showFileModal() {
      this.fileModal = true;
    },
    closeFileModal() {
      this.fileModal = false;
    },
    showGuarantorModal() {
      this.guarantorModal = true;
    },
    closeGuranatorModal() {
      this.guarantorModal = false;
    },
    async getLoan() {
      try {
        this.message = "Getting loan details...";
        this.pageLoading = true;
        const res = await ApiService.get(`loan/other/view/${this.slug}`);
        this.loanData = res.data.data;
        console.log(this.loanData);
        this.statusQuery = this.loanData.loan_status;
        if (
          this.loanData.loan_status == "pending" ||
          this.loanData.loan_status == "rejected"
        ) {
          this.application_editable = false;
        }
        this.disursement_info.duration = this.loanData.duration;
        this.disursement_info.amount_approved = this.loanData.amount_requested;
        this.pageLoading = false;
        this.getLoanTrail();
        if (this.can("pull-credit-report") || this.can("credit-report")) {
          this.getCreditReport();
        }
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    async getLoanTrail() {
      try {
        const res = await ApiService.get(
          `loan/other/loan_trails/${this.loanData.id}`
        );
        console.log(res);
        this.loanTrails = res.data.data;
        this.pageLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getStates() {
      try {
        const response = await ApiService.get("utility/state-list");
        this.states = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    onFilePickedGuarantorImageButton() {
      this.guarantor_info.image_file = this.$refs.fileChangeGuarantorImage.files[0];
    },
    onPickGuarantorImageButton() {
      this.$refs.fileChangeGuarantorImage.click();
    },
    onFilePickedGuarantorIdButton() {
      this.guarantor_info.id_file = this.$refs.fileChangeGuarantorId.files[0];
    },
    onPickButtonGuarantorIdButton() {
      this.$refs.fileChangeGuarantorId.click();
    },
    onPickFileButton() {
      this.$refs.fileChangeFile.click();
    },
    onFilePickedFileButton() {
      this.file_info.file = this.$refs.fileChangeFile.files[0];
    },
    async createGuarantor() {
      console.log(this.guarantor_info);
      let formData = new FormData();
      formData.append("name", this.guarantor_info.name);
      formData.append("address", this.guarantor_info.address);
      formData.append("phone_number", this.guarantor_info.phone_number);
      formData.append("alt_phone_number", this.guarantor_info.alt_phone_number);
      formData.append("image_file", this.guarantor_info.image_file);
      formData.append("id_file", this.guarantor_info.id_file);
      formData.append("other_loan_id", this.loanData.id);
      formData.append("id", this.guarantor_info.id);
      const headers = { "Content-Type": "multipart/form-data" };
      this.pageLoading = true;
      this.message = "Creating guarantor...";

      try {
        this.create_guarantor_loading = true;
        const response = await ApiService.post(
          "loan/other/upload_gurantor",
          formData,
          { headers }
        );
        this.create_guarantor_loading = false;
        this.pageLoader = false;
        this.closeGuranatorModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        await this.getLoan();
      } catch (error) {
        console.log(error);
        this.pageLoader = false;
        let _error = error.response.data;
        this.create_guarantor_loading = false;
        console.log(_error);
        ErrorService.displayErrorAlert(_error);
      }
    },
    async createFile() {
      //validations
      if (!this.file_info.name) {
        Swal.fire({
          title: "Error",
          text: "Please enter a name",
          icon: "error",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        return;
      }

      if (!this.file_info.file) {
        Swal.fire({
          title: "Error",
          text: "Please select a file",
          icon: "error",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        return;
      }

      let formData = new FormData();
      formData.append("name", this.file_info.name);
      formData.append("file", this.file_info.file);
      if (this.file_info.comment) {
        formData.append("comment", this.file_info.comment);
      }
      formData.append("type", "file");
      formData.append("other_loan_id", this.loanData.id);
      const headers = { "Content-Type": "multipart/form-data" };
      try {
        this.create_file_loading = true;
        this.pageLoading = true;
        this.message = "Creating file...";
        const response = await ApiService.post(
          "loan/other/create_file",
          formData,
          { headers }
        );
        this.create_file_loading = false;

        this.closeFileModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.closeFileModal();
        this.pageLoading = false;
        this.getLoan();
      } catch (error) {
        console.log(error);
        this.pageLoading = false;
        let _error = error.response.data;
        this.create_file_loading = false;
        console.log(_error);
        ErrorService.displayErrorAlert(_error);
      }
    },
    async deleteFile(id) {
      const swalResponse = await Swal.fire({
        title: `<div>
                    <h5 class="font-weight-600">Are you sure want to delete this file?</h5>
                  </div>`,
        text: "You are about to create a loan application",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }
      try {
        this.pageLoading = true;
        this.message = "Deleting file...";
        const response = await ApiService.get(`loan/other/delete_file/${id}`);
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async deleteGuarantor(id) {
      const swalResponse = await Swal.fire({
        title: `<div>
                    <h5 class="font-weight-600">Are you sure want to delete this guarantor?</h5>
                  </div>`,
        text: "You are about to create a loan application",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }
      try {
        this.message = "Deleting Guarantor...";
        this.pageLoading = true;
        const response = await ApiService.get(
          `loan/other/delete_guarantor/${id}`
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.pageLoading = false;
        this.getLoan();
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        ErrorService.displayErrorAlert(_error);
      }
    },
    async submitApplication() {
      const swalResponse = await Swal.fire({
        title: `<div>
                    <h5 class="font-weight-600">
                      Are you sure you want to submit loan Application?
                    </h5>
                  </div>`,
        text: "You are about to submit loan application",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      try {
        this.pageLoading = true;
        this.submit_loading = true;
        this.message = "Submitting Application...";
        const response = await ApiService.post(
          `loan/other/submit_application`,
          {
            other_loan_id: this.loanData.id
          }
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.submit_loading = false;
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        this.submit_loading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async submitRiskAssesment() {
      const swalResponse = await Swal.fire({
        title: `<div>
                    <h5 class="font-weight-600">
                      Are you sure you want to submit Risk Assesment?
                    </h5>
                    <p>Your Analysis is below</p>
                  </div>`,
        text: `${this.risk_review.risk_analysis}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      try {
        this.pageLoading = true;
        this.submit_loading = true;
        this.message = "Submitting Risk Assesment...";
        this.risk_review["other_loan_id"] = this.loanData.id;
        const response = await ApiService.post(
          `loan/other/review_risk_assesment`,
          this.risk_review
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.submit_loading = false;
        this.closeRiskReviewModal();
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        this.submit_loading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async submitAppReview() {
      this.closeAppReviewModal();
      const swalResponse = await Swal.fire({
        title: `<div>
                    <h5 class="font-weight-600">
                      Are you sure you want to submit Application Review?
                    </h5>
                  </div>`,
        text: "You are about to submit Application Review",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      try {
        this.pageLoading = true;
        this.submit_loading = true;
        this.message = "Submitting Application Review...";
        this.app_review["other_loan_id"] = this.loanData.id;
        const response = await ApiService.post(
          `loan/other/review_application`,
          this.app_review
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.submit_loading = false;
        this.closeAppReviewModal();
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        this.submit_loading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async disburseLoan() {
      //validations
      if (!this.disursement_info.status) {
        Swal.fire({
          title: "Error",
          text: "Please select a status",
          icon: "error",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        return;
      }

      if (this.disursement_info.status == "approved") {
        if (!this.disursement_info.duration) {
          Swal.fire({
            title: "Error",
            text: "Please enter a duration",
            icon: "error",
            timer: 3000,
            confirmButtonText: "Close",
            showConfirmButton: false
          });
          return;
        }

        if (!this.disursement_info.interest_rate) {
          Swal.fire({
            title: "Error",
            text: "Please enter an interest rate",
            icon: "error",
            timer: 3000,
            confirmButtonText: "Close",
            showConfirmButton: false
          });
          return;
        }

        if (!this.disursement_info.loan_account_number) {
          Swal.fire({
            title: "Error",
            text: "Please enter a loan account number",
            icon: "error",
            timer: 3000,
            confirmButtonText: "Close",
            showConfirmButton: false
          });
          return;
        }
      }

      this.disbursementModal = false;
      let message = "";
      if (this.disursement_info.status === "approved") {
        message = `<div>
              <h5 class="font-weight-600">
                Are you sure you want to Disburse Loan with the following info?
                <ul>
                  <li>Duration: ${this.disursement_info.duration}</li>
                  <li>Interest Rate: ${this.disursement_info.interest_rate}</li>
                  <li>Loan Account Number: ${this.disursement_info.loan_account_number}</li>
                </ul>
              </h5>
            </div>`;
      } else if (this.disursement_info.status === "cancel") {
        message = "Are you sure you want to cancel this disbursement";
      }

      const swalResponse = await Swal.fire({
        title: message,
        text: `You are about to ${this.disursement_info.status} Disbursement`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      try {
        this.pageLoading = true;        
        this.message = "Disbursing Loan...";
        const response = await ApiService.post(`loan/other/disburse_loan`, {
          other_loan_id: this.loanData.id,
          status: this.disursement_info.status,
          duration: this.disursement_info.duration,
          interest_rate: this.disursement_info.interest_rate,
          charges: this.disursement_info.charges,
          amount_approved: this.disursement_info.amount_approved,
          loan_account_number: this.disursement_info.loan_account_number
        });
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.pageLoading = false;
        this.closeDisbursemenModal();
        this.getLoan();
      } catch (error) {
        console.log(error);
        this.disbursementModal = false;
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateLoanStatus() {
      this.closeUpdateLoanStatusModal();
      const swalResponse = await Swal.fire({
        title: `<div>
                    <h5 class="font-weight-600">
                      Are you sure you want to Update Application Status?
                    </h5>
                  </div>`,
        text: `You are about to Update Application Status to ${this.loan_status}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      try {
        this.pageLoading = true;
        this.laon_status_loading = true;
        this.message = "Submitting Update Loan Status...";
        const response = await ApiService.post(
          `loan/other/update_loan_status`,
          {
            other_loan_id: this.loanData.id,
            status: this.loan_status
          }
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.laon_status_loading = false;
        this.closeUpdateLoanStatusModal();
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        this.laon_status_loading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getCreditReport() {
      try {
        this.message = "Submitting Update Loan Status...";
        const response = await ApiService.post(
          `loan/other/pull_credit_report`,
          {
            bvn: this.loanData.bvn
          }
        );

        this.credit_report = response.data.data;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        // ErrorService.displayErrorAlert(_error);
      }
    },
    async createRepayment() {
      const swalResponse = await Swal.fire({
        title: `Are you sure you want to create Repayment of ${this.r_amount}`,
        text: `You are about to create Repayment`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!"
      });

      if (!swalResponse.isConfirmed) {
        return;
      }

      var _data = {
        other_loan_id: this.loanData.id,
        payment_method: this.r_payment_method,
        description: this.r_payment_description,
        amount: this.r_amount
      };

      try {
        this.pageLoading = true;
        this.message = "Creating Repayment...";
        const response = await ApiService.post(
          `loan/other/create_repayment`,
          _data
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.closeRepayModal();
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async updateLoanCBAStatus() {
      try {
        this.pageLoading = true;
        this.message = "Checking Status...";
        const response = await ApiService.post(
          `loan/other/update_loan_cba_status`,
          {
            other_loan_id: this.loanData.id
          }
        );
        this.pageLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getLoan();
      } catch (error) {
        console.log(error);
        let _error = error.response.data;
        console.log(_error);
        this.pageLoading = false;
        this.submit_loading = false;
        ErrorService.displayErrorAlert(_error);
      }
    }
  },
  mounted() {
    this.getLoan();
    this.getStates();
  },
  computed: {
    userObj() {
      return this.$store.getters.userObj;
    },
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  }
};
</script>

<style></style>
